/* Fetch Success List Overview */
import { DateTime } from 'luxon';
import queryString from 'query-string';
import { CommissionYearStatistics } from 'src/adminPanelV2/api/commissionsV2';
import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { CommissionType } from 'src/entities/commission-account/CommissionEntry';

export const fetchCommissionEntriesByFilter = (
    year: number | null,
    month: number | null,
    type: CommissionType,
    ignoreEligibility: boolean = false,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId();
    const endpoint = `/api/customer/partner/${customerId}/commissions${query}`;

    const headers: Record<string, string> = {
        type,
        ignoreEligibility: ignoreEligibility.toString(),
    };

    if (year != null && month != null) {
        headers.xdate = DateTime.fromObject({ year, month, day: 1 }).toISODate();
    }

    return callApi(endpoint, {
        headers,
    });
};

export const fetchCommissionStats = (
    selectedYear: number,
    compareYear: number,
    type: CommissionType,
    ignoreEligibility: boolean = false
): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/partner/${customerId}/commissions/${selectedYear}/${compareYear}`;

    return callApi(endpoint, {
        headers: {
            type,
            ignoreEligibility: ignoreEligibility.toString(),
        },
    });
};

/** R68 item 13: the Provisionskonto's payout gate — without loading the legacy commission list. */
export const fetchCommissionPayoutEligible = (): Promise<CallApiResult<boolean>> =>
    callApi('/api/customer/partner/current/commissionPayoutEligible');

/** R65 item 8c: the caller's year statistics from ordering's live bookings — the AdminPanel's read for one partner. */
export const fetchMyCommissionStatistics = (year: number): Promise<CallApiResult<CommissionYearStatistics>> =>
    callApi('/api/ordering/v2/commissions/me/statistics', { params: { year } });
